import React from "react";
import styles from "@src/components/helpers.module.scss";

export const SumIcon: React.FC = () => {
	return (
		<div className={styles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path
					d="M12 4.6665V3.33317C12 3.15636 11.9298 2.98679 11.8047 2.86177C11.6797 2.73674 11.5101 2.6665 11.3333 2.6665H4.33333C4.27143 2.6665 4.21075 2.68374 4.15809 2.71629C4.10543 2.74883 4.06288 2.7954 4.03519 2.85077C4.00751 2.90613 3.99579 2.96812 4.00135 3.02977C4.00691 3.09143 4.02952 3.15031 4.06667 3.19984L7.06667 7.19984C7.23976 7.43063 7.33333 7.71134 7.33333 7.99984C7.33333 8.28833 7.23976 8.56904 7.06667 8.79984L4.06667 12.7998C4.02952 12.8494 4.00691 12.9082 4.00135 12.9699C3.99579 13.0316 4.00751 13.0935 4.03519 13.1489C4.06288 13.2043 4.10543 13.2508 4.15809 13.2834C4.21075 13.3159 4.27143 13.3332 4.33333 13.3332H11.3333C11.5101 13.3332 11.6797 13.2629 11.8047 13.1379C11.9298 13.0129 12 12.8433 12 12.6665V11.3332"
					fill="currentColor"
					strokeWidth="0.666667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};
